import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import Appoinment from './Appoinment';
import AppoinmentTest from './AppoinmentTest';
import WalkInBooking from './WalkInBooking';
import Feedback from './Feedback';
import PrivacyPolicy from './PrivacyPolicy';
import CustomDomainRoute from './CustomDomainRoute';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
const SignupPage = Loadable(lazy(() => import('pages/auth/Signup')));
const LandingPage = Loadable(lazy(() => import('pages/LandingPage')));
const EnterCompany = Loadable(lazy(() => import('pages/auth/EnterCompany')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/home',
          element: <LandingPage />
        },
        {
          path: '/login',
          element: <LoginPage />
        },
        {
          path: '/signup',
          element: <SignupPage />
        },
        {
          path: '/enter-company',
          element: <EnterCompany />
        },
        {
          path: '/appointment/:slug',
          element: <AppoinmentTest />
        },
        {
          path: '/walk-in/:id',
          element: <WalkInBooking />
        },
        {
          path: '/register',
          element: <RegisterPage />
        },
        {
          path: '/feedback',
          element: <Feedback />
        },
        {
          path: '/privacy-policy',
          element: <PrivacyPolicy />
        }
      ]
    }
  ]
};

export default LoginRoutes;
